import app from 'flarum/forum/app';
import RealtimeState from '../RealtimeState';
const REMOVED = 'removed';
const HIDDEN_EVENTS = ['postHidden', 'discussionHidden'];
/**
 * Hidden, deleted and restored content, live. The server sends `removed` only
 * to members who could see the item and can't now, on their own channel; the
 * public channel's copy is for guests. Members who can still see it (e.g.
 * moderators, for a hidden post) get its new state instead.
 */
export default function Visibility() {
  RealtimeState.onUserChannelReady(channel => bind(channel, false));
  RealtimeState.onPublicChannelReady(channel => bind(channel, true));
}
function bind(channel, isPublic) {
  channel.bind(REMOVED, data => {
    if (isPublic && app.session.user) return;
    remove(data);
  });
  for (const event of HIDDEN_EVENTS) {
    channel.bind(event, data => {
      app.store.pushPayload(data);
      m.redraw();
    });
  }
}

/** As if this member had deleted it themselves: the same calls core's controls make. */
function remove(_ref) {
  let {
    data,
    meta
  } = _ref;
  if (data.type === 'posts') {
    const post = app.store.getById('posts', data.id);
    const discussion = post && post.discussion() || (meta?.discussionId ? app.store.getById('discussions', meta.discussionId) : null);
    discussion?.removePost(data.id);
  }
  if (data.type === 'discussions') {
    const discussion = app.store.getById('discussions', data.id);
    if (discussion) {
      app.discussions.removeDiscussion(discussion);
      if (app.viewingDiscussion(discussion)) {
        app.alerts.show({
          type: 'error'
        }, app.translator.trans('flarum-realtime.forum.discussion-removed'));
        app.history.back();
      }
    }
  }
  m.redraw();
}
flarum.reg.add('flarum-realtime', 'forum/extend/Visibility', Visibility);